<template>
  <div class="w-full flex flex-row bg-gray-100 h-full" :class="{ 'mt-3': !isMultiSite, 'mt-12': isMultiSite }">
    <div class="flex flex-col w-full" :class="{ '  md:mr-6 ': mode != 'edit', 'right-80 ': mode == 'edit' }">
      <div class="hidden fixed h-10 bg-blue-200 w-full flex items-center justify-center" :class="{ hidden: notification == undefined }"><div v-html="notification"></div></div>

      <nav class="fixed w-full border-gray-50   z-30 bg-white" :class="{ 'top-0 ': !isMultiSite, 'top-9 ': isMultiSite }">
        <div class="flex flex-row items-center justify-between px-4">
          <button
            type="button"
            @click="openMenu"
            class="inline-flex items-center p-2 text-sm text-gray-900 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200   "
            aria-expanded="false"
          >
            <span class="sr-only">Open main menu</span>
            <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          <div v-if="mode == 'edit'" class="w-full flex items-center justify-start bg-gray-50 mr-3 cursor-pointer" @click="onSelectEdit">
            <i class="fa-solid fa-chevron-left mr-2" /> <span class="text-blue-700">Retour</span>
          </div>

          <div v-if="mode != 'edit'" class="hidden w-full flex justify-end bg-gray-100 mr-3 cursor-pointer items-center text-sm semi-bold text-gray-700" @click="onSelectEdit">
            <i class="fa-solid fa-pen-to-square mr-2" />
            <span>Personnaliser</span>
          </div>
          <div v-if="mode == 'edit'" class="w-full flex justify-end bg-gray-100 mr-3 cursor-pointer" @click="onSelectEdit">
            <button
              type="button"
              class="hidden flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg bg-gray-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300   focus:outline-none "
              @click="onSaveSheet"
            >
              {{ common_labels["BUTTON_SAVE"][lg] }}
            </button>
          </div>
        </div>

        <div v-if="mode != 'edit'">
          <div id="navbar-dropdown-dashboard" class="my-2 w-full md:block md:w-auto px-6">
            <ul
              class="w-full flex flex-col items-center md:py-4 px-2 mt-4 border border-gray-50 bg-gray-400 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0 md:bg-white   "
            >
              <li v-for="(tab, indexTab) in tabs" :key="tab.id">
                <a
                  href="#"
                  class="block py-2 pr-3 rounded md:bg-transparent md:p-0 "
                  :class="{ 'font-bold  text-gray-50 bg-blue-700  md:bg-transparent md:text-blue-700 md:p-0': currentTab == indexTab }"
                  aria-current="page"
                  @click="selectTab(indexTab)"
                  >{{ tab.name["FR"] }}</a
                >
              </li>
              <li class="hidden">
                <button @click="addTab">
                  <i class="fa-solid fa-circle-plus" />
                </button>
              </li>
              <li class="flex-grow hidden md:block"></li>
              <li class="w-full md:w-auto ml-auto flex justify-end px-3">
                <ContentDropdowns @valueChanged="selectPeriod"> </ContentDropdowns>
              </li>
              <li class="w-1"></li>
            </ul>
          </div>
        </div>
      </nav>

      <div class="w-full bg-gray-100 flex flex-row pb-6 "  :class="{ 'mt-24': !isMultiSite, 'mt-16 ': isMultiSite }">
        <div class="w-full xl:pr-3">
          <div class="flex flex-wrap w-full px-3">
            <div v-for="(section, indexSection) in dashboard?.sections" :id="indexSection.id" :key="section?._id" class="p-1 lg:p-2 xl:p-1 group flex flex-wrap" :class="getSectionClass(section)">
              <ChartSectionComponent
                class="w-full h-auto"
                :id="section._id"
                :section="section"
                :tab="currentTab"
                :refresh="refresh"
                :config="item"
                :class="section.class_chart"
                :reports="reports"
                :period_global="currentPeriod"
                freezer="false"
                @editProperties="OnEditDiagram"
                @updateValue="OnUpdateValue"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <aside
      id="default-sidebar"
      class="fixed flex flex-col bg-gray-100 top-1 right-0 border-l-2 border-l-gray-200 z-10 h-[calc(100vh-5rem)] transition-transform -translate-x-full sm:translate-x-0 pt-2"
      :class="{ 'flex w-96': mode == 'edit', 'hidden w-0': mode != 'edit' }"
      aria-label="Sidebar"
    >
      <div class="relative h-full w-full px-1 py-1 overflow-y-auto bg-white ">
        <ul class="font-medium px-1">
          <li class="flex flex-row w-full items-center border-b-1 border-b-gray-300 px-2 h-16 bg-gray-300">
            <div class="w-full text-left justify-left cursor-pointer flex flex-row items-center" @click="onCloseEdit">
              <div class="flex flex-row items-center px-1">
                <span class="text-gray-600 font-bold text-lg">Agent B4Food</span>
              </div>
            </div>
            <div class="w-full text-left justify-end cursor-pointer flex px-3" @click="onCloseEdit">
              <i class="fa-solid fa-xmark" />
            </div>
          </li>
          <li class="flex flex-row w-full items-center border-b-1 border-b-gray-300 px-2">
            <div class="flex items-start gap-2.5">
              <img class="w-8 h-8 rounded-full" src="https://files.b4food.io/b4food/images/64b583450ff4d4705bcea51f?icon=true" alt="Jese image" />
              <div class="flex flex-col w-full max-w-[320px] leading-1.5 p-4 border-gray-200 bg-gray-100 rounded-e-xl rounded-es-xl ">
                <div class="flex items-center space-x-2 rtl:space-x-reverse">
                  <span class="text-sm font-semibold text-gray-900 ">You</span>
                  <span class="text-sm font-normal text-gray-500 ">11:46</span>
                </div>
                <p class="text-sm font-normal py-2.5 text-gray-900 ">Quel est le volume de lait reçu hier ?</p>
                <span class="hidden text-sm font-normal text-gray-500 ">Delivered</span>
              </div>
              <button
                id="dropdownMenuIconButton"
                data-dropdown-toggle="dropdownDots"
                data-dropdown-placement="bottom-start"
                class="inline-flex self-center items-center p-2 text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none  focus:ring-gray-50   "
                type="button"
              >
                <svg class="w-4 h-4 text-gray-500 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 4 15">
                  <path d="M3.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6.041a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5.959a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
                </svg>
              </button>
              <div id="dropdownDots" class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-40  ">
                <ul class="py-2 text-sm text-gray-700 " aria-labelledby="dropdownMenuIconButton">
                  <li>
                    <a href="#" class="block px-4 py-2 hover:bg-gray-100 ">Reply</a>
                  </li>
                  <li>
                    <a href="#" class="block px-4 py-2 hover:bg-gray-100 ">Forward</a>
                  </li>
                  <li>
                    <a href="#" class="block px-4 py-2 hover:bg-gray-100 ">Copy</a>
                  </li>
                  <li>
                    <a href="#" class="block px-4 py-2 hover:bg-gray-100 ">Report</a>
                  </li>
                  <li>
                    <a href="#" class="block px-4 py-2 hover:bg-gray-100 ">Delete</a>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <li class="mt-3 flex flex-row w-full items-center border-b-1 border-b-gray-300 px-2">
            <div class="flex items-start gap-2.5">
              <img
                src="data:image/png;base64,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"
                class="w-8 h-8 rounded-full"
                alt="B4food.io"
              />

              <div class="flex flex-col w-full max-w-[320px] leading-1.5 p-4 border-gray-200 bg-gray-100 rounded-e-xl rounded-es-xl ">
                <div class="flex items-center space-x-2 rtl:space-x-reverse">
                  <span class="text-sm font-semibold text-gray-900 ">B4Food Agent</span>
                  <span class="text-sm font-normal text-gray-500 ">11:48</span>
                </div>
                <p class="text-sm font-normal py-2.5 text-gray-900  text-left justify-start">Le volume reçu de lait hier réceptionné hier est de 3760 litres. ?</p>
                <span class="hidden text-sm font-normal text-gray-500 ">Fin</span>
              </div>
              <button
                id="dropdownMenuIconButton"
                data-dropdown-toggle="dropdownDots"
                data-dropdown-placement="bottom-start"
                class="inline-flex self-center items-center p-2 text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none  focus:ring-gray-50   "
                type="button"
              >
                <svg class="w-4 h-4 text-gray-500 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 4 15">
                  <path d="M3.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6.041a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5.959a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
                </svg>
              </button>
              <div id="dropdownDots" class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-40  ">
                <ul class="py-2 text-sm text-gray-700 " aria-labelledby="dropdownMenuIconButton">
                  <li>
                    <a href="#" class="block px-4 py-2 hover:bg-gray-100 ">Reply</a>
                  </li>
                  <li>
                    <a href="#" class="block px-4 py-2 hover:bg-gray-100 ">Forward</a>
                  </li>
                  <li>
                    <a href="#" class="block px-4 py-2 hover:bg-gray-100 ">Copy</a>
                  </li>
                  <li>
                    <a href="#" class="block px-4 py-2 hover:bg-gray-100 ">Report</a>
                  </li>
                  <li>
                    <a href="#" class="block px-4 py-2 hover:bg-gray-100 ">Delete</a>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>

        <ul class="hidden font-medium px-1">
          <li class="flex flex-row w-full items-center border-b-1 border-b-gray-300 px-2">
            <div class="w-full text-left justify-left cursor-pointer flex flex-row items-center" @click="onCloseEdit">
              <div class="flex flex-row items-center px-1">
                <i class="fa-solid fa-pen-to-square mr-6" />
                <span class="text-gray-600 font-bold text-lg">Personnalisation</span>
              </div>
            </div>
            <div class="w-full text-left justify-end cursor-pointer flex" @click="onCloseEdit">
              <i class="fa-solid fa-xmark" />
            </div>
          </li>

          <li class="flex flex-col justify-start w-full items-center border-b-1 border-b-gray-300 pt-3 pb-2">
            <label for="small-input" class="w-full text-left block mb-2 text-sm font-medium text-gray-900 ">Nom</label>
            <input
              id="dasboard-tab-input"
              v-model="tabName"
              type="text"
              class="block w-full py-2 text-gray-900 border border-gray-300 rounded-sm bg-gray-50 text-xs focus:ring-blue-500 focus:border-blue-500      "
              @change="onChangeTabName"
            />
          </li>
          <li class=" ">
            <draggable
              ghost-class="ghost"
              class="mt-4 w-full min-h-24 border-1 border-solid items-start flex flex-col bg-white mb-3 border-gray-300 p-1"
              :list="lines"
              item-key="id"
              @start="drag = true"
              @end="drag = false"
              @change="onChange"
            >
              <template #header2>
                <div class="hidden mb-2 w-full py-2 flex justify-center" role="group">
                  <button
                    type="button"
                    class="flex items-center justify-left px-4 py-2 text-sm font-medium text-white rounded-lg bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300   focus:outline-none "
                    @click="onOpenList"
                  >
                    <i class="fa-solid fa-plus mr-2 text-color-gray-500" />

                    {{ labels["BUTTON_ADD"][lg] }}
                  </button>
                </div>
              </template>

              <template #item="{ element }">
                <div
                  class="h-10 px-1 cursor-pointer list-group mt-2 w-full flex items-center bg-gray-100 border border-gray-200 rounded-sm shadow   flex flex-row justify-center"
                >
                  <div class="flex flex-col items-center w-6">
                    <i class="fa-solid fa-grip-vertical text-gray-600" />
                  </div>

                  <div class="flex flex-col items-center w-full pl-1 max-w-60">
                    <div class="h-6 flex flex-row items-center w-full">
                      <div class="w-full flex items-center w-full">
                        <label class="truncate text-left block text-sm w-full font-normal text-gray-600 ">
                          {{ element.name }}
                        </label>
                      </div>

                      <div class="hidden w-auto flex w-full items-center justify-end pr-1">
                        <div class="w-auto flex flex-row items-center justify-center" />
                      </div>
                    </div>
                  </div>

                  <div class="flex flex-col items-center w-6 ml-2" @click="OnDeleteDiagram(element)">
                    <i class="fa-regular fa-circle-xmark text-gray-600" />
                  </div>
                </div>
              </template>
            </draggable>
          </li>
          <li>
            <div class="bottom-16 cursor-pointer w-full flex items-center px-2 bg-gray-100 pb-4 w-full">
              <button
                class="h-10 cursor-pointer list-group mt-2 w-full flex items-center bg-gray-50 border border-gray-200 dotted rounded-sm shadow   flex-row justify-center"
                type="button"
                data-drawer-target2="drawer-right-examples"
                data-drawer-show2="drawer-right-examples"
                data-drawer-placement="right"
                aria-controls="drawer-right-examples"
                @click="onOpenIndicatorsDrawer"
              >
                <div class="flex flex-col items-center w-full pl-1">
                  <div class="h-6 flex flex-row items-center w-full">
                    <div class="flex flex-col items-center w-6">
                      <i class="fa-solid fa-plus text-gray-600" />
                    </div>

                    <div class="w-full flex items-center w-full cursor-pointer">
                      <label class="cursor-pointer text-left block text-sm w-full font-normal text-gray-600 "> Ajouter </label>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </li>
        </ul>
      </div>
      <div class="bottom-16 cursor-pointer w-full flex flex-col items-center px-2 bg-gray-100 pb-4 w-full border-t border-t-gray-300">
        <label for="message" class="block mb-2 text-sm font-medium text-gray-900 ">Votre message</label>

        <div class="relative w-full">
          <textarea
            id="message"
            rows="4"
            class="relative block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500      "
            placeholder="Write your thoughts here..."
          >
          </textarea>
          <i class="absolute bottom-5 right-5 fa-solid fa-play"></i>
        </div>
        <button
          class="hidden h-10 cursor-pointer list-group mt-2 w-full flex items-center border bg-red-800 text-white border-gray-200 dotted rounded-lg shadow flex-row justify-center"
          type="button"
          data-drawer-placement="right"
          aria-controls="drawer-right-examples"
          @click="onOpenIndicatorsDrawer"
        >
          <div class="flex flex-col items-center w-full pl-1 w-full justify-center">
            <div class="h-6 flex flex-row items-center text-center justify-center">
              <div class="flex flex-col items-center w-6">
                <i class="fa-solid fa-trash" />
              </div>

              <div class="w-full flex items-center w-full cursor-pointer">
                <label class="pl-2 cursor-pointe block text-sm font-semibold"> Supprimer </label>
              </div>
            </div>
          </div>
        </button>
      </div>
    </aside>

    <EditDiagramModal :input="recordEditDiagram" @close="OnSelectEditDiagramClose" @validate="OnSelectEditDiagramValidate" />
    <DeleteDiagramModal :input="recordDeleteDiagram" @close="OnSelectDeleteDiagramClose" @confirm="OnSelectDeleteDiagramConfirm" />
    <DashboardDrawer :input="resetSelectedIndicators" @close="onCloseIndicatorsDrawer" @add="onAddIndicatorsDrawer" />
  </div>
</template>

<script>
import common_labels from "@/assets/lg/common.json";
import draggable from "vuedraggable";

import service from "@/services/FullService.vue";

import ChartSectionComponent from "@/components/ChartSectionComponent.vue";
import { Modal, Drawer } from "flowbite";
import EditDiagramModal from "@/components/modals/EditDiagramModal.vue";
import DeleteDiagramModal from "@/components/modals/DeleteDiagramModal.vue";
import DashboardDrawer from "@/components/DashboardDrawer.vue";
import ContentDropdowns from "@/components/content/ContentDropdowns.vue";

import { mapGetters } from "vuex";

export default {
  name: "DashboardViewEx",
  components: {
    draggable,
    EditDiagramModal,
    DeleteDiagramModal,
    DashboardDrawer,
    ChartSectionComponent,
    ContentDropdowns,
    // MapSession
  },
  props: {},
  data: function () {
    return {
      refresh: String,
      mode: "chat",
      lg: "FR",
      drawerIndicators: null,
      temp1: "-",
      temp2: "-",
      temp3: "-",
      common_labels: common_labels,
      sample1: "-",
      currentTab: 0,
      tabName: "",
      recordTemp1: [],
      notification: "<a href='/admin/views/inbound-invoices?state=DRAFT&page=1'><b>12 factures a valider</b></a>",
      recordTemp2: [],
      recordTemp3: [],
      resetSelectedIndicators: 0,
      reports: {},
      currentPeriod: { label: "2025-2026", period: "01 juil. 2025 - 30 juin 2026", started_at: "2025-07-01", ended_at: "2026-06-30" },
      deleteDiagramModal: null,
      selectedChart: null,
      editDiagramModal: null,
      recordEditDiagram: {},
      recordDeleteDiagram: {},
      lines: [],
      tabs: [],
      dashboard: {
        title: "",
        sections: [],
      },
    };
  },
  computed: {
    isMultiSite: function () {
      //return (this.user?.tenant?.entities?.length > 0)
      return this.user?.isMultiEntities == true;
    },
    ...mapGetters({ user: "StateUser" }),
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
  },

  watch: {
    refresh: async function () {
      await this.loadDashboard();
    },
    "user.tenant_id": async function () {
      await this.loadDashboard();
    },
    "user.entity_id": async function () { //PATH POST
 
       this.refresh = new Date().toISOString();
   
    },
    "$route.params.id": async function () {
      await this.loadDashboard();
    },
    "$route.query": async function () {
 

      if (this.$route.query.tab != undefined) {
        this.currentTab = parseInt(this.$route.query.tab);
      }

      await this.loadDashboard();
    },
    lines: function () {},
  },
  async mounted() {
    if (this.user == undefined) {
      this.$router.push("/login");
      return;
    }

    if (this.$route.query.tab != undefined) {
      this.currentTab = parseInt(this.$route.query.tab);
    }

    const modalEl2 = document.getElementById("edit-diagram-modal");
    this.editDiagramModal = new Modal(modalEl2, {
      placement: "center",
    });

    const modalEl3 = document.getElementById("delete-diagram-modal");
    this.deleteDiagramModal = new Modal(modalEl3, {
      placement: "center",
    });

    await this.loadDashboard();
  },
  methods: {
    openMenu: function () {
      this.$emit("openMenu");
    },
    OnUpdateValue: function (/*item*/) {},
    async selectPeriod(period) {
      this.currentPeriod = period;
      this.refresh = new Date().toISOString();
    },

    addTab() {
      this.tabs.push({
        name: {
          FR: "Autre",
          EN: "Autre",
        },
        sections: [],
      });
      this.currentTab++;

      if (this.dashboard == null) this.dashboard = {};

      this.dashboard.sections = [];
      this.updateDashboard();
      this.listRight();
      this.mode = "chat";
      this.$nextTick(function () {
        document.getElementById("dasboard-tab-input").focus();
      });
    },
    onOpenIndicatorsDrawer() {
      // set the drawer menu element

      if (this.drawerIndicators == undefined) {
        const $targetEl = document.getElementById("drawer-dashboard-indicators");
        // options with default values
        const options = {
          placement: "right",
          backdrop: true,
          bodyScrolling: false,
          edge: false,
          edgeOffset: "",
          backdropClasses: "bg-gray-900/50 /80 fixed inset-0 z-30",
        
        };

        // instance options object
        const instanceOptions = {
          id: "drawer-dashboard-indicators",
          override: true,
        };

        this.drawerIndicators = new Drawer($targetEl, options, instanceOptions);
      }
      this.resetSelectedIndicators = new Date().getTime();
      this.drawerIndicators.show();
    },
    onCloseIndicatorsDrawer() {
      this.drawerIndicators.hide();
    },
    async onAddIndicatorsDrawer(items) {
 
      let sections = this.dashboard.sections;
      let dashboards = [];
      for (let i = 0; i < items.length; i++) {
        //  let id = v4();
        dashboards.push(items[i]._id);
        //   sections.push(chart);
        //   tabs.sections.push(chart);
      }
      let id = this.$route.params.id;
      if (id == undefined) return;
      try {
        let response = await service.addRecord("dashboards/" + id + "/data-sources", this.user?.token, { tab: this.currentTab, dashboards: dashboards });
        for (let u = 0; u < response.length; u++) {
          sections.push(response[u]);
        }
      } catch (e) {
        console.log(e);
      }
      this.dashboard.sections = sections;
      this.tabs[this.currentTab].sections = sections;
      this.listRight();
      this.drawerIndicators.hide();
      //     this.updateDashboard()
    },
    async getRemoteData(id) {
      let filter = {};
      if (id == undefined) {
        return {
          total: 0,
          records: [],
        };
      }
      let records = await service.generateReport("data-sources/" + id + "/charts", this.user?.token, Object.assign({}, { limit: 10, offset: 0 }, filter));
      return records;
    },
    onRefeshChart: async function (item) {
    

      let source_id = item?.config?.source?.id;
      // let source_id = "663522bde3498f69e81035bd"

      let response = await this.getRemoteData(source_id);
 
      this.reports[item.id] = response;
    },
    array_move: function (arr, old_index, new_index) {
      if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr; // for testing
    },
    onCloseEdit: function () {
      this.mode = "";
    },
    OnDeleteDiagram: function (item) {
      this.recordDeleteDiagram = item;
      this.deleteDiagramModal.show();
    },
    //Manage Delete Modal
    OnSelectDeleteDiagramClose: function () {
      this.deleteDiagramModal.hide();
    },
    OnSelectDeleteDiagramConfirm: function (item) {
      this.recordDeleteDiagram = item;

      for (let j = 0; j < this.dashboard.sections.length; j++) {
     

        if (item.id != undefined)
          if (this.dashboard.sections[j]._id == item.id) {
            this.dashboard.sections.splice(j, 1);

            this.lines.splice(j, 1);
          }
      }
      this.deleteDiagramModal.hide();
      this.updateDashboard();
    },
    OnSelectEditDiagramValidate: function () {
      this.editDiagramModal.hide();
      this.updateDashboard();
    },
    OnSelectEditDiagramClose: function () {
      this.editDiagramModal.hide();
    },
    OnEditDiagram: function (item) {
      this.recordEditDiagram = item;
      this.editDiagramModal.show();
    },

    onChange: function (item) {
 
      this.array_move(this.tabs[this.currentTab]?.sections, item.moved.oldIndex, item.moved.newIndex);
      this.updateDashboard();
      //  this.array_move(this.tabs[this.currentTab]?.sections[0]?.cols, item.moved.oldIndex, item.moved.newIndex)
 
    },
    editDiagram: function () {},
    onSelectEdit: function () {
      if (this.mode == "edit") this.mode = "closed";
      else this.mode = "edit";
    },
    selectTab: function (n) {
      //  window.location = "/admin/dashboard/" + this.$route.params.id + "?tab=" + n
      //this.currentTab = n;
      //this.dashboard = this.tabs[this.currentTab]

      let id = this.$route.params.id;

      if (id == undefined) id = "main";

      this.$router.push("/admin/dashboard/" + id + "?tab=" + n);

      //this.listRight()
    },
    getSectionHeight: function (item) {
      if (item == undefined) return "h-96";
      return "h-" + item.height;
    },
    getContainerClass: function (item) {
      if (item == undefined) return "";
      //   return 'grid grid-cols-' + item.cols.length + ' gap-4 mb-6'
      return " " + item.class_container;
    },
    getSectionClass: function (item) {
      if (item == undefined) return "";
      //   return 'grid grid-cols-' + item.cols.length + ' gap-4 mb-6'
      return " " + item.class;
    },
    getBodyClass: function (col) {
      // if (item == undefined) return
      if (col == undefined) return "";
      return col.class;
      //return 'h-' + col.height + ' grid   gap-4  grid grid-cols-' + col.items.length + ' gap-4 mb-6'
    },
    onChangeTabName() {
      this.tabs[this.currentTab].name[this.lg] = this.tabName;
      this.updateDashboard();
    },
    listRight: function () {
      let lines = [];
      this.tabName = this.tabs[this.currentTab]?.name[this.lg];
      for (let y = 0; y < this.tabs[this.currentTab]?.sections?.length; y++) {
        // for (let z = 0; z < this.tabs[this.currentTab].sections[y].cols.length; z++) {
        lines.push({ id: this.tabs[this.currentTab].sections[y]._id, name: this.tabs[this.currentTab].sections[y].title });
        // }
      }
      this.lines = lines;
    },
    updateDashboard: async function () {
      let id = this.$route.params.id;
      if (id == undefined) return;
      try {
        await service.updateRecord("dashboards", id, this.user?.token, { tabs: this.tabs });
        
      } catch (e) {
        console.log("Erreur Update Dashboard --------- ");
        console.log(e);
      }
    },
    loadDashboard: async function () {
 
      if (this.user == undefined) {
    //   alert("this.user");
        return;
      }

      let id = this.$route.params.id;
      if (id == undefined) {
     
        return;
      }
      let config = await service.getDataId("dashboards", id, this.user?.token, {});
    
      //  let config = { records: [tpl], total: 1 };

      if (config != undefined) {
       
        this.dashboard = config?.tabs[this.currentTab];
 
        this.tabs = config?.tabs;
        this.listRight();
        return;
      }
      this.dashboard = { tabs: [] };
      this.listRight();
    },
    TransformData: function (records) {
      let response = [];

      for (let i = 0; i < records.length; i++) {
        //  let line = records[records.length - i - 1];
        let line = records[i];

        for (let j = 0; j < line.grouped_data.length; j++) {
          // let index = line.grouped_data.length - j - 1
          let subline = line.grouped_data[j];

          // let index = line.grouped_data.length - j - 1
          // let subline = line.grouped_data[index]

          if (subline.value < 0) response.push(-subline.value);
          else response.push(subline.value);
        }
      }

      let reverse = [];
      for (let k = 0; k < response.length; k++) {
        reverse[k] = response[response.length - k - 1];
      }

      return reverse;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
